<template>
      <div class="copy footer" style=" line-height:28px;">
        <div class="wraper" style="padding-top: 25px;font-size: 14px;display: flex;align-content: space-between">
          <div style="line-height: 30px;height: 30px;width: 700px;"><span>主办单位：青海省民政厅</span>
          <div style="line-height: 30px;height: 30px;display: flex;justify-content: left;align-items: center"><img src="../../static/images/logo_img.png" style="margin-right: 5px;">
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=63010402000208" style="color: white;margin-right: 10px;" target="_blank"> 青公网安备63010402000208号</a>&nbsp;
            <a href="https://beian.miit.gov.cn/#/Integrated/index" style="color: white" target="_blank">青ICP备05001072号-8</a></div>
          </div>

          <div style="width: 300px;display: flex;align-content: center;text-align: center;">
            <a href="javascript:void(0)" @click="showPublicImg"><img src="../../static/images/fixed_icon11.png" style="width: 60px;height: 60px;"><p style="line-height: 20px;color: white">青海民政公众号</p></a>
            <a href="javascript:void(0)" @click="showPublicApkImg" style="margin-left: 10px;"><img src="../../static/images/PublicApkDownLoadPic.png"  style="width: 60px;height: 60px;"><p  style="line-height: 20px;color: white">青民通办APP</p></a>
          </div>

        </div>
        <el-dialog
          :visible.sync="showFlag" :lockScroll="false"
          width="500px" >
          <div style="width: 100%;text-align: center">
          <img src="../../static/images/public/public_ewm2.jpg" style="width:300px;height: 300px;"/>
          <div style="width: 100%;line-height: 30px;">*请使用手机微信扫码关注</div>
          </div>
        </el-dialog>
        <el-dialog
          :visible.sync="apkShowFlag" :lockScroll="false"
          width="500px" >
          <div style="width: 100%;text-align: center">
          <img src="../../static/images/PublicApkDownLoadPic.png" style="width:300px;height: 300px;"/>
          <div style="width: 100%;line-height: 30px;">*请使用安卓手机扫码下载</div>
          </div>
        </el-dialog>

      </div>

</template>

<script>

  import headers from "./Headers";
  import fixedDiv from "./FixedDiv";
  import imgUploader from "./ImgUploader";
  export default {


    name: "fixedDiv",
    props:{
    },

    data(){
      return{
        showFlag:false,

        apkShowFlag:false,


        formLabelWidth: '120px',



        dialogImageUrl: '',
        dialogVisible: false,
        disabled: false,

      }
    },

    created(){
    },
    methods:{
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    },
      beforeUpload(file){
        if(file.size>10485760) {
          this.$alert('文件大小不能超过10M', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        return true;
      },

      afterReadOne(files) {
        if (files) {
          files.status = 'uploading';
          files.message = '上传中...';
          files.type = 'suggest_' + this.suggestId;
          this.afterReadFile(files);
        }
      },

      afterReadFile(file) {
        var loading = this.$loading({
          lock: true,
          text: '数据处理中,请耐心等待....',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        file.status = 'uploading';
        let formData = new FormData;
        formData.append('_sk', 'app');
        formData.append('upload', file.file);
        formData.append('type', file.type);
        formData.append('attachName', this.$util.uuid.uuid2());
        var ttt = this;
        this.$https.postFile('attach/upload.do', formData, (response) => {
          if (response.status === 200 && response.data.isOk) {
            // file.attachId=response.data.bean.attach_id;
            ttt.file_ids.push(response.data.bean.attach_id);
            file.status = 'done';
            file.file.attrId = response.data.bean.attach_id
            // file.uid = response.data.bean.attach_id
          } else {
            file.status = 'failed';
          }
          loading.close();
        });
        //重新验证表单项
        // this.$refs['photo'].resetValidation();
      },
      deleteone(file) {
        this.file_ids.remove(file.raw.attrId);
        return true;
      },
      showPublicImg(){
        this.showFlag=true;
      },
      showPublicApkImg(){
        this.apkShowFlag=true;
      },
      handleRemove(file) {
        console.log(file);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleDownload(file) {
        console.log(file);
      }
    }
  }
</script>
<style>
/*  .el-dialog__header {
    padding: 20px 20px 10px;
    background-color: #2c62ec;
  }*/
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue